import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCreateRedxOrderMutation } from '../../../services/redxApi';

const CreateRedxOrderModal = ({ show, handleClose, orderData }) => {
  const [createRedxOrder] = useCreateRedxOrderMutation();
  const [formData, setFormData] = useState({
    customer_name: orderData?.customer_name || '',
    customer_phone: orderData?.customer_phone || "+8801906703380",
    delivery_area: orderData?.delivery_area || 'Dhaka',
    delivery_area_id: orderData?.delivery_area_id || 1,
    customer_address: orderData?.customer_address || '',
    merchant_invoice_id: orderData?.invoiceId || '',
    cash_collection_amount: orderData?.grossTotalRound || 0,
    parcel_weight: orderData?.item_weight || 1,
    instruction: orderData?.note || '',
    value: orderData?.item_price || 0,
    is_closed_box: true|| false,
    pickup_store_id: 1,
    parcel_details_json: [
      {
        name: orderData?.item_description || 'Product',
        category: 'General',
        value: orderData?.item_price || 0
      }
    ]
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Format the data according to API requirements
      const apiData = {
        ...formData,
        cash_collection_amount: formData.cash_collection_amount.toString(),
        is_closed_box: formData.is_closed_box.toString()
      };

      const response = await createRedxOrder(apiData).unwrap();
      
      if (response.status) {
        toast.success(response.message || 'Order created successfully!');
        handleClose();
      } else {
        toast.error(response.message || 'Failed to create order');
      }
    } catch (error) {
      console.error('RedX Order Error:', error);
      
      if (error.status === 'PARSING_ERROR') {
        toast.error('Server error: Invalid response format');
      } else if (error.status === 404) {
        toast.error('API endpoint not found. Please check the server configuration.');
      } else if (error.status === 401) {
        toast.error('Authentication failed. Please login again.');
      } else {
        toast.error(error?.data?.message || 'Failed to create order. Please try again.');
      }
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Create RedX Order</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Customer Name</Form.Label>
            <Form.Control
              type="text"
              name="customer_name"
              value={formData.customer_name}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Customer Phone</Form.Label>
            <Form.Control
              type="text"
              name="customer_phone"
              value={formData.customer_phone}
              onChange={handleChange}
              required
              placeholder="e.g., 01712345678"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Delivery Area</Form.Label>
            <Form.Control
              type="text"
              name="delivery_area"
              value={formData.delivery_area}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Delivery Area ID</Form.Label>
            <Form.Control
              type="number"
              name="delivery_area_id"
              value={formData.delivery_area_id}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Customer Address</Form.Label>
            <Form.Control
              type="text"
              name="customer_address"
              value={formData.customer_address}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Merchant Invoice ID</Form.Label>
            <Form.Control
              type="text"
              name="merchant_invoice_id"
              value={formData.merchant_invoice_id}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Cash Collection Amount</Form.Label>
            <Form.Control
              type="number"
              name="cash_collection_amount"
              value={formData.cash_collection_amount}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Parcel Weight (kg)</Form.Label>
            <Form.Control
              type="number"
              name="parcel_weight"
              value={formData.parcel_weight}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Instructions</Form.Label>
            <Form.Control
              as="textarea"
              rows={2}
              name="instruction"
              value={formData.instruction}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Parcel Value</Form.Label>
            <Form.Control
              type="number"
              name="value"
              value={formData.value}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Is Closed Box</Form.Label>
            <Form.Select
              name="is_closed_box"
              value={formData.is_closed_box}
              onChange={handleChange}
              required
            >
              <option value={true}>Yes</option>
              <option value={false}>No</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Pickup Store ID</Form.Label>
            <Form.Control
              type="number"
              name="pickup_store_id"
              value={formData.pickup_store_id}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Create Order
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateRedxOrderModal; 